
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"18.3","height":"18.3","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"layer"},[_c('path',{attrs:{"d":"M10.546 9.132l7.425-7.425A.999.999 0 1 0 16.557.293L9.132 7.718 1.707.293A.999.999 0 1 0 .293 1.707l7.425 7.425-7.425 7.424a.999.999 0 1 0 1.414 1.414l7.425-7.424 7.425 7.424a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-7.425-7.424z","fill":"#399E8B"}})])])
      }
    
      }
    